export default [
  {
    path: '/app/defines/document-groups',
    name: 'DocumentGroups',
    component: () => import('@/views/Defines/Document_groups/Index.vue'),
    meta: {
      pageTitle: 'Doküman Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'DOCUMENT_GROUPS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/defines/document-groups/add',
    name: 'DocumentGroupsAdd',
    component: () => import('@/views/Defines/Document_groups/Add.vue'),
    meta: {
      pageTitle: 'Doküman Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/document-groups',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'DOCUMENT_GROUPS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/defines/document-groups/edit/:id',
    name: 'DocumentGroupsEdit',
    component: () => import('@/views/Defines/Document_groups/Edit.vue'),
    meta: {
      pageTitle: 'Doküman Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/document-groups',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'DOCUMENT_GROUPS_EDIT',
      action: 'read',
    },
  },
]
